import { useSearchParams } from 'react-router-dom'

export const useDatasetsIds = () => {
  const [params] = useSearchParams()
  return params.get('datasets')?.split(',')
}
